import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Location, NgTemplateOutlet, NgStyle } from '@angular/common';
import { patterns, SharedService } from '../../shared.service';
import { ApiService } from '../../api.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SalesViewService } from 'src/app/components/pages/sales/sales-view.service';
import { PermissionsService } from '../../permissions/permissions.service';
import { FormsModule } from '@angular/forms';
import { PaginationComponent } from 'ngx-bootstrap/pagination';
import { HighlightPipe } from '../../highlight.pipe';

@Component({
    selector: 'app-search-details',
    templateUrl: './search-details.component.html',
    styleUrl: './search-details.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, RouterLink, NgTemplateOutlet, NgStyle, PaginationComponent, HighlightPipe]
})
export class SearchDetailsComponent {
  term: string = '';
  searched_string = '';
  emptyData: boolean=true;
  results:any=[];
  show: any = {
    doctor: false,
    contract: false,
    patient: false,
    partner: false,
    payments: false,
    ar: false,
    proposal: false,
    pa_leads: false,
    training:false,
    leads: false
  };
  public searchSubscription: Subscription | undefined;
  public search_type:any
  public pageNumber: number = 1;
  public totalRows:any=0;
  private readonly pageSize = 10;
  // Cap-driven flags used to scope the sales/search-lead request and route lead
  // clicks, mirroring SearchComponent.
  private isTeamLead = false;
  private isManager = false;
  private isAgentL1Pure = false;
  private isAgentL2Pure = false;
  private isTeamLeadL1 = false;
  private isTeamLeadL2 = false;
  private permissionsDestroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    public location: Location,
    public router: Router,
    private _shared: SharedService,
    private _api: ApiService,
    private salesView: SalesViewService,
    private permissions: PermissionsService
  ) {
  }
// .pipe(
//       map(params => params['search']),// map value according to search then send to next operators and subsciber
//       distinctUntilChanged(),//to avoid duplicate API calls for the same value in one row
//     )
  ngOnInit() {
    this.permissions.snapshot$
      .pipe(takeUntil(this.permissionsDestroy$))
      .subscribe(() => this.computePermissionFlags());
    this.computePermissionFlags();
    this.searchSubscription = this.route.queryParams.subscribe((data: any) => {
       this.search_type=data.search_type
       this.show[data.search_type]=true;
        this.searchData(data.search);
        this.handleSearch();

    });
  }

  private computePermissionFlags(): void {
    const flags = this.permissions.salesPermissionFlags;
    this.isTeamLead = flags.isTeamLead;
    this.isManager = flags.isManager;
    this.isAgentL1Pure = flags.isAgentL1Pure;
    this.isAgentL2Pure = flags.isAgentL2Pure;
    this.isTeamLeadL1 = flags.isTeamLeadL1;
    this.isTeamLeadL2 = flags.isTeamLeadL2;
  }

  searchData(data: any) {
    this.term = data;
      const isPhoneNumber = patterns.some(pattern => pattern.test((this.term + '').trim()));
      if (isPhoneNumber) {
        console.log(isPhoneNumber)
        const digits = (this.term + '').match(/\d+/g);
        this.term = digits ? digits.join('') : '';
      }
  }

  search(){
    this.searchData(this.term);
    // Reset to the first page so a fresh search doesn't reuse the previous offset.
    this.pageNumber = 1;
    this.router.navigate(['/app/details-search'], {queryParams: {search: this.term, search_type:this.search_type}, queryParamsHandling: 'merge'})
  }

  handleSearch() {
    if (!this.term) {
      this._shared.customPopups('Enter a value to search', 2);
      return;
    }

    // Leads use a different, paginated API (sales/search-lead) with limit/offset.
    if (this.search_type === 'leads') {
      this.fetchLeads();
      return;
    }

    let data = {
      search_string: this.term,
      search_type:this.search_type,
      page:this.pageNumber
    };
    this._api.api(data, 'dashboard/details-search', 'get')
      .subscribe((res: any) => {
        console.log(res);
        this.results=res.list;
        this.totalRows=res.count;
        if(this.results &&  this.results.length>0) {
         this.searched_string = this.term;
          this.emptyData = false;
        } else {
           this.emptyData = true;
          this._shared.customPopups('No results found!', 1);
        }
      });
  }

  private fetchLeads() {
    const data: any = {
      search_string: this.term,
      timezone: this._shared.getTimezoneZone() || 'America/Los_Angeles',
      limit: this.pageSize,
      offset: (this.pageNumber - 1) * this.pageSize,
    };

    if (this.isTeamLead || this.isManager) {
      data.view_as = this.salesView?.dashboardView ? this.salesView?.dashboardView : 'my';
    }

    if (this.isTeamLead && this.salesView.effectiveSelectedAdminId != null) {
      data.selected_admin_id = this.salesView.effectiveSelectedAdminId;
    }

    this._api.api(data, 'sales/search-lead', 'get')
      .subscribe((res: any) => {
        this.results = res.data?.filteredLeads || [];
        this.totalRows = res.data?.number_of_records || 0;
        if (this.results && this.results.length > 0) {
          this.searched_string = this.term;
          this.emptyData = false;
        } else {
          this.emptyData = true;
          this._shared.customPopups('No results found!', 1);
        }
      });
  }
  viewPartner(partner_id: any) {
    // MainService.customSetItem("partnerList", partner_id);
    this.router.navigate(['app', 'partners', 'profile', partner_id]);
  }

  navigateToDetails(lead: any) {
    const queryParams: any = { lead_id: lead.lead_id, doctor_id: lead.doctor_id };
    // Mirrors SearchComponent: agents/TLs forward their tier's sales_l{N}_id;
    // managers forward based on the active dashboardView toggle.
    if ((this.isTeamLeadL1 || this.isAgentL1Pure) && lead?.sales_l1_id != null) {
      queryParams.admin_id = lead.sales_l1_id;
    } else if ((this.isTeamLeadL2 || this.isAgentL2Pure) && lead?.sales_l2_id != null) {
      queryParams.admin_id = lead.sales_l2_id;
    } else if (this.isManager && this.salesView.dashboardView === 'L1') {
      queryParams.admin_id = lead.sales_l1_id;
    } else if (this.isManager && this.salesView.dashboardView === 'L2') {
      queryParams.admin_id = lead.sales_l2_id;
    }
    this.router.navigate(['app/sales/my-leads-details'], { queryParams });
  }

  pageChanged(event: any) {
    this.pageNumber = event.page;
    this.handleSearch();
  }

  ngOnDestroy() {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    this.permissionsDestroy$.next();
    this.permissionsDestroy$.complete();
  }
}